export type Language = 'ru' | 'en';

export const SUPPORTED_LANGUAGES: Language[] = ['ru', 'en'];

const STORAGE_KEY = 'rr_lang';
const RUSSIAN_SPEAKING_PREFIXES = ['ru', 'uk', 'be', 'kk'];

const isLanguage = (value: unknown): value is Language =>
  SUPPORTED_LANGUAGES.includes(value as Language);

const readStoredLanguage = (): Language | null => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isLanguage(stored) ? stored : null;
  } catch {
    return null;
  }
};

const detectBrowserLanguage = (): Language => {
  const preferred = navigator.languages?.length ? navigator.languages : [navigator.language];
  const speaksRussian = preferred.some(tag =>
    RUSSIAN_SPEAKING_PREFIXES.some(prefix => (tag || '').toLowerCase().startsWith(prefix))
  );
  return speaksRussian ? 'ru' : 'en';
};

export const LANGUAGE: Language = readStoredLanguage() ?? detectBrowserLanguage();

/** BCP 47 локаль для `Intl.*` / `toLocale*String` — вместо литерала `'ru-RU'`. */
export const LOCALE = LANGUAGE === 'ru' ? 'ru-RU' : 'en-GB';

// Перезагрузка вместо реактивности: тексты лежат и в модульных константах.
export const setLanguage = (language: Language): void => {
  if (language === LANGUAGE) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    return;
  }
  window.location.reload();
};
